import { Routes } from '@angular/router';
import { AuthGuard } from "./guards/auth.guard";
import { errorRoute } from './layouts';
import { AuthSuccessGuard } from "./guards/auth-success.guard";
var LAYOUT_ROUTES = errorRoute.slice();
var ɵ0 = {
    authorities: ['ROLE_USER']
};
var routes = [
    {
        path: 'login',
        loadChildren: './modules/login/login.module#LoginModule',
        canActivate: [AuthSuccessGuard]
    },
    {
        path: 'dashboard',
        data: ɵ0,
        canActivate: [AuthGuard],
        loadChildren: './modules/dashboard/dashboard.module#DashboardModule'
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    }
].concat(LAYOUT_ROUTES);
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0 };
